<script>
// Sales Widget
import { Bar } from 'vue-chartjs'
import { ChartConfig } from "Constants/chart-config";

export default ({
   extends: Bar,
   props: {
      record : Object
   },
   data: function () {
      return {
         options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
               yAxes: [{
                  stacked: true,
                  ticks: {
                     display: false
                  },
                  gridLines: {
                     display: false,
                     drawBorder: false
                  }
               }],
               xAxes: [{
                  stacked: true,
                  ticks: {
                     padding: 10
                  },
                  barPercentage: 0.4,
                  categoryPercentage: 1.3,
                  gridLines: {
                     display: false,
                     drawBorder: false
                  }
               }]
            },
            legend: {
               display: false
            }
         }
      }
   },
   mounted() {
      //this.executeChart();
     // console.log ("mounted");
   },
   created() {
       //console.log ("created..");
       //this.executeChart();
   },
    watch: { 
      	record: function(newVal, oldVal) { // watch it
          this.executeChart();
        }
   },
    methods: {
      executeChart() {
          
      var arrHeader = [];
      var arrApps = [];
      var arrAppsWeb = [];

      for (let i = 0; i < this.record.Graphics.length; i++) {
          arrHeader.push (this.record.Graphics[i].DatStr);
          arrApps.push (this.record.Graphics[i].Value1);
          arrAppsWeb.push (this.record.Graphics[i].Value2);
      }
     

      this.renderChart({
         labels: arrHeader,
         datasets: [
            {
               type: 'bar',
               label: 'Omzet',
               backgroundColor: ChartConfig.color.primary,
               hoverBackgroundColor: ChartConfig.color.primary,
               borderWidth: 0,
               data: arrApps
            },
            {
               type: 'bar',
               label: 'Transacties',
               backgroundColor: ChartConfig.lineChartAxesColor,
               hoverBackgroundColor: ChartConfig.lineChartAxesColor,
               borderWidth: 0,
               data: arrAppsWeb
            }
         ]
      }, this.options)
	}
  }
})
</script>
